import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  Segment,
  Table,
  Button,
  Label,
  Icon,
  Radio,
  Grid,
} from "semantic-ui-react";
import "../../../scss/index.scss";
import { estiloSegmento } from "../../../estilos/segmentos";
import { estiloBotones } from "../../../estilos";
import { apiSubastador } from "../../../api/subastador";
import { ENTORNO } from "../../../utils/constantes";
import { SinConexionAInternet } from "../../Public/SinConexionAInternet";
import { getrole, setTitulo } from "../../../utils/variablesLocales";
import PropTypes from "prop-types";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import CssBaseline from "@mui/material/CssBaseline";
import useScrollTrigger from "@mui/material/useScrollTrigger";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Fab from "@mui/material/Fab";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import Fade from "@mui/material/Fade";
import IconButton from "@mui/material/IconButton";
import HomeIcon from "@mui/icons-material/Home";

const apisubastador = new apiSubastador();

function ScrollTop(props) {
  const { children, window } = props;
  // Note that you normally won't need to set the window ref as useScrollTrigger
  // will default to window.
  // This is only being set here because the demo is in an iframe.
  const trigger = useScrollTrigger({
    target: window ? window() : undefined,
    disableHysteresis: true,
    threshold: 100,
  });

  const handleClick = (event) => {
    const anchor = (event.target.ownerDocument || document).querySelector(
      "#back-to-top-anchor"
    );

    if (anchor) {
      anchor.scrollIntoView({
        block: "center",
      });
    }
  };

  return (
    <Fade in={trigger}>
      <Box
        onClick={handleClick}
        role="presentation"
        sx={{ position: "fixed", bottom: 16, right: 16 }}
      >
        {children}
      </Box>
    </Fade>
  );
}

ScrollTop.propTypes = {
  children: PropTypes.element.isRequired,
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window: PropTypes.func,
};

export function Subastador(props) {
  setTitulo("Subastador");

  const navigate = useNavigate();

  const navigateToInicio = async () => {
    navigate(ENTORNO.URL_APLICACION + "/Administrador/Inicio");
  };

  ////////////////////////////////

  const [subastadores, setSubastador1] = useState(null);
  // const [yaCargo, setyaCargo] = useState(false);
  const [ActualizacionAutomatica, setActualizacionAutomatica] = useState(0);

  useEffect(() => {
    (async () => {
      try {
        //controlando la seguridad para que solo acceda a esta pantalla el perfil que corresponda
        if (getrole() !== "Administrador") {
          navigate(ENTORNO.URL_APLICACION + "/CerrarSesion");
        }
        ///////////////////////////////////////////////////////

        // setInterval(async () => {
        //   const response = await apisubastador.obtenerConductoresActivos();
        //   setSubastador1(response);
        // }, 5000);
      } catch (error) {
        console.error(error);
      }
    })();
  });

  ////////////////////////////////

  var subastadorRegistros = [];

  if (subastadores) {
    for (let i = 0; i < subastadores.length; i++) {
      subastadorRegistros.push({
        Localidad: subastadores[i].Localidad,
        Nombre: subastadores[i].Nombre,
        Apellido: subastadores[i].Apellido,
        Marca: subastadores[i].Vehiculo_Marca,
        Modelo: subastadores[i].Vehiculo_Modelo,
        Color: subastadores[i].Vehiculo_Color,
        Dominio: subastadores[i].Vehiculo_Dominio,
        Pasajero: subastadores[i].Viaje_Pasajero,
        Estado: subastadores[i].Viaje_Estado,
        Partida: subastadores[i].Viaje_Partida,
        Destino: subastadores[i].Viaje_Destino,
        Min: subastadores[i].Viaje_Min,
        Kms: subastadores[i].Viaje_Kms,
        PrecioBase: subastadores[i].Viaje_PrecioBase,
        PrecioSugerido: subastadores[i].Viaje_PrecioSugerido,
      });
    }
  }

  ////////////////////////////////

  const Actualizar = async () => {
    await apisubastador.ofrecerViajeAConductor();

    const response1 = await apisubastador.obtenerConductoresActivos();
    // setyaCargo(true);
    setSubastador1(response1);
  };

  const handleChange = (event, { value }) => {
    setActualizacionAutomatica(ActualizacionAutomatica === 1 ? 0 : 1);
  };

  return (
    <div style={{ overfxlow: "hidden", touchAction: "none" }}>
      <div className="divPrincipal_ImportarNomina">
        <React.Fragment>
          <CssBaseline />
          <AppBar style={{ background: "#DC030E" }}>
            <Toolbar>
              <IconButton
                size="large"
                edge="start"
                color="inherit"
                onClick={navigateToInicio}
                aria-label="menu"
                sx={{ mr: 2 }}
              >
                <HomeIcon />
              </IconButton>
              <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
                Subastador
              </Typography>
            </Toolbar>
          </AppBar>
          <Toolbar id="back-to-top-anchor" />
          <Container>
            <Box sx={{ my: 2 }}>
              <Segment style={estiloSegmento.Administrador}>
                <Grid
                  textalign="center"
                  container
                  style={{ padding: "5em 0em" }}
                >
                  <div className="ingresar">
                    <Grid.Row style={{ width: "100%" }}>
                      <Grid.Column style={{ width: "100%" }}>
                        <Segment style={estiloSegmento.Administrador}>
                          <Radio
                            toggle
                            checked={ActualizacionAutomatica === 1}
                            onChange={handleChange}
                            style={{
                              zIndex: "0",
                            }}
                            label={
                              ActualizacionAutomatica === 1
                                ? "Actualización automática"
                                : "Actualización manual"
                            }
                          />
                          <br></br>
                          <br></br>
                          {ActualizacionAutomatica === 0 ? (
                            <Button
                              style={estiloBotones.Nuevo}
                              as="a"
                              onClick={() => Actualizar()}
                            >
                              Actualizar
                            </Button>
                          ) : (
                            <div></div>
                          )}
                          <br></br>
                          <br></br>
                          <Table compact celled>
                            <Table.Header>
                              <Table.Row>
                                <Table.HeaderCell textAlign="center">
                                  Localidad
                                </Table.HeaderCell>
                                <Table.HeaderCell textAlign="center">
                                  Chofer
                                </Table.HeaderCell>
                                <Table.HeaderCell textAlign="center">
                                  Vehículo
                                </Table.HeaderCell>
                                <Table.HeaderCell textAlign="center">
                                  Viaje
                                </Table.HeaderCell>
                                <Table.HeaderCell textAlign="center">
                                  Estado
                                </Table.HeaderCell>
                              </Table.Row>
                            </Table.Header>

                            <Table.Body>
                              {subastadorRegistros.map((fila, key) => (
                                <Table.Row key={key}>
                                  <Table.Cell textAlign="center">
                                    {fila.Localidad}
                                  </Table.Cell>
                                  <Table.Cell textAlign="center">
                                    {fila.Nombre}&nbsp;{fila.Apellido}
                                  </Table.Cell>
                                  <Table.Cell textAlign="center">
                                    {fila.Marca}&nbsp;{fila.Modelo}&nbsp;
                                    {fila.Color}
                                    <br></br>
                                    {fila.Dominio}
                                  </Table.Cell>
                                  <Table.Cell textAlign="center">
                                    {fila.Pasajero === "Disponible" ? (
                                      <div></div>
                                    ) : (
                                      <div>
                                        Partida: {fila.Partida}
                                        <br></br>
                                        Destino: {fila.Destino}
                                        <br></br>
                                        <br></br>
                                        <Label>
                                          <Icon name="map outline" />
                                          {fila.Kms} Kms
                                        </Label>
                                        <Label>
                                          <Icon name="clock outline" />
                                          {fila.Min} Min
                                        </Label>
                                        <Label>
                                          <Icon name="dollar sign" />
                                          {fila.PrecioSugerido} pesos
                                        </Label>
                                      </div>
                                    )}
                                  </Table.Cell>
                                  <Table.Cell textAlign="center">
                                    {fila.Pasajero === "Disponible" ? (
                                      <Label tag size="large">
                                        {fila.Pasajero}
                                      </Label>
                                    ) : (
                                      <div></div>
                                    )}

                                    {fila.Estado ===
                                    "PENDIENTE DE ACEPTAR VIAJE" ? (
                                      <div>
                                        <Label color="teal" tag>
                                          PENDIENTE DE ACEPTAR VIAJE
                                        </Label>
                                        <br></br>
                                        <small>SUBASTA</small>
                                      </div>
                                    ) : (
                                      <div></div>
                                    )}

                                    {fila.Estado === "CONDUCTOR ASIGNADO" ? (
                                      <div>
                                        <Label color="green" tag>
                                          CONDUCTOR ASIGNADO
                                        </Label>
                                        <br></br>
                                        <small>POST-SUBASTA</small>
                                      </div>
                                    ) : (
                                      <div></div>
                                    )}

                                    {fila.Estado ===
                                    "RUTA DE VIAJE ACTIVADA" ? (
                                      <div>
                                        <Label color="orange" tag>
                                          RUTA DE VIAJE ACTIVADA
                                        </Label>
                                        <br></br>
                                        <small>POST-SUBASTA</small>
                                      </div>
                                    ) : (
                                      <div></div>
                                    )}

                                    {fila.Estado === "TRANSITO ACTIVADO" ? (
                                      <div>
                                        <Label color="blue" tag>
                                          TRANSITO ACTIVADO
                                        </Label>
                                        <br></br>
                                        <small>PRE-TRANSITO</small>
                                      </div>
                                    ) : (
                                      <div></div>
                                    )}
                                  </Table.Cell>
                                </Table.Row>
                              ))}
                            </Table.Body>
                          </Table>
                        </Segment>
                      </Grid.Column>
                    </Grid.Row>
                  </div>
                </Grid>
                <SinConexionAInternet></SinConexionAInternet>
              </Segment>
            </Box>
          </Container>
          <ScrollTop {...props}>
            <Fab size="small" aria-label="scroll back to top">
              <KeyboardArrowUpIcon />
            </Fab>
          </ScrollTop>
        </React.Fragment>
      </div>
    </div>
  );
}
